"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/esnext.iterator.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserProvider = void 0;
Object.defineProperty(exports, "storage", {
  enumerable: true,
  get: function get() {
    return _localStorageFallback.default;
  }
});
exports.withUser = void 0;
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.date.to-json.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _auth0Js = require("auth0-js");
var _localStorageFallback = _interopRequireDefault(require("local-storage-fallback"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var emptyMetadata = {
  authorization: {
    roles: [],
    groups: [],
    permissions: []
  }
};

// HOC auth0 provider
var UserProvider = exports.UserProvider = /*#__PURE__*/function (_Component) {
  function UserProvider() {
    var _this;
    _classCallCheck(this, UserProvider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UserProvider, [].concat(args));
    _defineProperty(_this, "state", {
      metadata: emptyMetadata,
      token: "",
      profile: {
        user_id: "",
        email: "",
        email_verified: false,
        picture: "",
        created_at: "",
        updated_at: "",
        identities: [{}]
      }
    });
    _defineProperty(_this, "handleVisibilityChange", function () {
      if (document.visibilityState === 'visible') {
        var isLoggedIn = !!_this.state.token;
        var idToken = _localStorageFallback.default.getItem("idToken");
        var accessToken = _localStorageFallback.default.getItem("accessToken");
        var expiresAt = JSON.parse(_localStorageFallback.default.getItem('expires_at'));
        if (expiresAt && accessToken) {
          var isExpired = expiresAt < Date.now();
          if (isExpired) {
            _this.renewAuth();
          }
        }
        if (isLoggedIn && !idToken) {
          _this.handleLogout();
        }
      }
    });
    _defineProperty(_this, "handleLogout", function () {
      _this.setState({
        metadata: emptyMetadata,
        token: "",
        profile: {
          user_id: "",
          email: "",
          email_verified: false,
          picture: "",
          created_at: "",
          updated_at: "",
          identities: [{}]
        }
      });
      _localStorageFallback.default.removeItem("idToken");
      _localStorageFallback.default.removeItem("accessToken");
      _localStorageFallback.default.removeItem("expires_at");
      clearTimeout(_this.tokenRenewalTimeout);
      _this.auth0.logout({
        returnTo: window.location.origin
      });
    });
    _defineProperty(_this, "getPopupHandler", function (initialScreen) {
      return function () {
        // pass params to Lock at universal login page
        var _this$props = _this.props,
          allowSignUp = _this$props.allowSignUp,
          languageDictionary = _this$props.languageDictionary;
        _this.auth0.authorize({
          // override state to make sure redirection url is up-to-date
          state: window.location.pathname + window.location.search,
          scope: "openid email app_metadata",
          // namespaced by "up_"
          up_initial_screen: initialScreen,
          up_allow_signup: allowSignUp,
          up_title: languageDictionary.title,
          up_signup_terms: languageDictionary.signUpTerms,
          up_social_login_instructions: languageDictionary.socialLoginInstructions
        });
      };
    });
    _defineProperty(_this, "handleShowLoginPopup", _this.getPopupHandler("login"));
    _defineProperty(_this, "handleShowSignupPopup", _this.getPopupHandler("signUp"));
    _defineProperty(_this, "getUserInfo", function (accessToken) {
      _this.auth0.client.userInfo(accessToken, function (err, profile) {
        if (!err && profile) {
          _this.setState({
            profile: {
              user_id: profile.user_id,
              email: profile.email,
              email_verified: profile.email_verified,
              picture: profile.picture,
              created_at: profile.created_at,
              updated_at: profile.updated_at,
              identities: profile.identities
            },
            metadata: profile.app_metadata,
            token: accessToken
          });
        }
      });
    });
    _defineProperty(_this, "setSession", function (auth) {
      _localStorageFallback.default.setItem("idToken", auth.idToken);
      _localStorageFallback.default.setItem("accessToken", auth.accessToken);
      _localStorageFallback.default.setItem("expires_at", JSON.stringify(auth.expiresIn * 1000 + new Date().getTime()));
      _this.getUserInfo(auth.accessToken);
      _this.scheduleRenewal();
    });
    _defineProperty(_this, "resumeAuth", function () {
      _this.auth0.parseHash({
        hash: window.location.hash
      }, function (err, auth) {
        if (!err && auth && auth.accessToken && auth.idToken) {
          _this.setSession(auth);
          _this.props.onAuthenticated(auth);
        }
      });
    });
    _defineProperty(_this, "renewAuth", function () {
      _this.auth0.checkSession({}, function (err, auth) {
        if (!err && auth && auth.accessToken && auth.idToken) {
          _this.setSession(auth);
        } else {
          _this.handleLogout(); // logout if unable to renew
        }
      });
    });
    _defineProperty(_this, "scheduleRenewal", function () {
      var delay = JSON.parse(_localStorageFallback.default.getItem('expires_at')) - Date.now();
      if (delay > 0) {
        _this.tokenRenewalTimeout = setTimeout(_this.renewAuth, delay);
      }
    });
    _defineProperty(_this, "initiateAuth0", function () {
      var _this$props2 = _this.props,
        clientId = _this$props2.clientId,
        domain = _this$props2.domain;
      _this.auth0 = new _auth0Js.WebAuth({
        clientID: clientId,
        domain,
        redirect: true,
        // redirect mode is preferred to maximize browser compatibility
        redirectUri: window.location.origin,
        responseType: "id_token token",
        // id_token is required to get idToken from response
        params: {
          scope: "openid email app_metadata"
        }
      });
    });
    return _this;
  }
  _inherits(UserProvider, _Component);
  return _createClass(UserProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      var userStatus = this.props.provideUserStatus(this.state.metadata ? this.state.metadata : emptyMetadata);
      return {
        user: {
          metadata: this.state.metadata,
          profile: this.state.profile,
          action: {
            showLoginPopup: this.handleShowLoginPopup,
            showSignupPopup: this.handleShowSignupPopup,
            logout: this.handleLogout
          },
          status: _objectSpread({
            isLoggedIn: !!this.state.token
          }, userStatus)
        }
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initiateAuth0();
      // handle page reload or new tab
      var accessToken = _localStorageFallback.default.getItem("accessToken");
      var isExpired = JSON.parse(_localStorageFallback.default.getItem('expires_at')) < Date.now();
      if (accessToken) {
        if (isExpired) {
          this.renewAuth();
        } else {
          this.getUserInfo(accessToken);
          this.scheduleRenewal();
        }
      }
      // handle hash after initial login
      if (window.location.hash) {
        this.resumeAuth();
      }
      // reload other tabs when token in storage changes
      window.addEventListener("storage", function (e) {
        if (e.isTrusted && e.key === "accessToken") {
          window.location.reload();
        }
      });

      // Add visibility change listener to renew idToken when tab is visible
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      clearTimeout(this.tokenRenewalTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.cloneElement(this.props.children, {
        key: this.state.token // token as key to force rerendering when token changes
      });
    }
  }]);
}(_react.Component); // HOC withUser
_defineProperty(UserProvider, "propTypes", {
  clientId: _propTypes.default.string.isRequired,
  domain: _propTypes.default.string.isRequired,
  allowSignUp: _propTypes.default.bool,
  languageDictionary: _propTypes.default.object,
  // languageDictionary of lock popup
  provideUserStatus: _propTypes.default.func,
  // generate and pass extra helper status via user.status
  onAuthenticated: _propTypes.default.func // callback after successful authentication, taking `state` from auth0 as argument, i.e. redirect to original path
});
_defineProperty(UserProvider, "childContextTypes", {
  user: _propTypes.default.object
});
_defineProperty(UserProvider, "defaultProps", {
  allowSignUp: true,
  languageDictionary: {
    title: "Unified Patents",
    signUpTerms: "I agree to Term of Use and Privacy Policy."
  },
  provideUserStatus: function provideUserStatus() {
    return {};
  },
  onAuthenticated: function onAuthenticated() {
    return {};
  }
});
var withUser = exports.withUser = function withUser(WrappedComponent) {
  var ComponentWithUser = function ComponentWithUser(props, context) {
    var newProps = _objectSpread(_objectSpread({}, props), {}, {
      user: context.user
    });
    return /*#__PURE__*/_react.default.createElement(WrappedComponent, newProps);
  };
  ComponentWithUser.contextTypes = {
    user: _propTypes.default.object
  };
  return ComponentWithUser;
};

// export localStorage fallback